import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createGlobalSlice, GlobalSlice } from "./slices/globalSlice";
import {
  createNotificationsSlice,
  NotificationsSlice
} from "./slices/notificationsSlice";
import { createDeliverySlice, DeliverySlice } from "./slices/deliverySlice";
import { createStatusSlice, StatusSlice } from "./slices/statusSlice";
import { createErrorSlice, ErrorSlice } from "./slices/errorSlices";
import { AdminSlice, createAdminSlice } from "./slices/adminSlice";
import { createCustomersSlice, CustomersSlice } from "./slices/customersSlice";
import { createDashboardSlice, DashboardSlice } from "./slices/dashboardSlice";
import { createSettingsSlice, SettingsSlice } from "./slices/settingsSlice";
import { createInboxSlice, InboxSlice } from "./slices/inboxSlice";
import {
  createGenerateOnetimeLoginSlice,
  GenerateOnetimeLoginSlice
} from "./slices/generateOnetimeLoginSlice";
import { createUserSlice, UserSlice } from "./slices/userSlice";
import {
  createResetPasswordSlice,
  ResetPasswordSlice
} from "./slices/resetPasswordSlice";
import { createInventorySlice, InventorySlice } from "./slices/inventorySlice";
import { createWizardSlice, WizardSlice } from "./slices/wizardSlice";
import { ArchiveSlice, createArchiveSlice } from "./slices/archiveSlice";
import { createToastNotificationSlice, ToastNotificationSlice } from "./slices/toastNotificationSlice";

export type RootState = {
  global: GlobalSlice;
  notifications: NotificationsSlice;
  delivery: DeliverySlice;
  status: StatusSlice;
  error: ErrorSlice;
  toastNotifications: ToastNotificationSlice;
  admin: AdminSlice;
  customers: CustomersSlice;
  dashboard: DashboardSlice;
  customerServerSettings: SettingsSlice;
  inbox: InboxSlice;
  generateOnetimeLogin: GenerateOnetimeLoginSlice;
  user: UserSlice;
  resetPassword: ResetPasswordSlice;
  inventory: InventorySlice;
  wizard: WizardSlice;
  archive: ArchiveSlice;
};

export const useRootStore = create<RootState>()(
  devtools((...args) => ({
    global: createGlobalSlice(
      ...(args as unknown as Parameters<typeof createGlobalSlice>)
    ),
    notifications: createNotificationsSlice(
      ...(args as unknown as Parameters<typeof createNotificationsSlice>)
    ),
    delivery: createDeliverySlice(
      ...(args as unknown as Parameters<typeof createDeliverySlice>)
    ),
    status: createStatusSlice(
      ...(args as unknown as Parameters<typeof createStatusSlice>)
    ),
    error: createErrorSlice(
      ...(args as unknown as Parameters<typeof createErrorSlice>)
    ),
    toastNotifications: createToastNotificationSlice(
      ...(args as unknown as Parameters<typeof createToastNotificationSlice>)
    ),
    admin: createAdminSlice(
      ...(args as unknown as Parameters<typeof createAdminSlice>)
    ),
    customers: createCustomersSlice(
      ...(args as unknown as Parameters<typeof createCustomersSlice>)
    ),
    dashboard: createDashboardSlice(
      ...(args as unknown as Parameters<typeof createDashboardSlice>)
    ),
    customerServerSettings: createSettingsSlice(
      ...(args as unknown as Parameters<typeof createSettingsSlice>)
    ),
    inbox: createInboxSlice(
      ...(args as unknown as Parameters<typeof createInboxSlice>)
    ),
    generateOnetimeLogin: createGenerateOnetimeLoginSlice(
      ...(args as unknown as Parameters<typeof createGenerateOnetimeLoginSlice>)
    ),
    user: createUserSlice(
      ...(args as unknown as Parameters<typeof createUserSlice>)
    ),
    resetPassword: createResetPasswordSlice(
      ...(args as unknown as Parameters<typeof createResetPasswordSlice>)
    ),
    inventory: createInventorySlice(
      ...(args as unknown as Parameters<typeof createInventorySlice>)
    ),
    wizard: createWizardSlice(
      ...(args as unknown as Parameters<typeof createWizardSlice>)
    ),
    archive: createArchiveSlice(
      ...(args as unknown as Parameters<typeof createArchiveSlice>)
    )
  }))
);
